import { render } from "./RollenFoerderorganisationenList.pug?vue&type=template&id=a14e8fe6&lang=pug"
import script from "./RollenFoerderorganisationenList.js?vue&type=script&lang=js"
export * from "./RollenFoerderorganisationenList.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__